(() => {
  const CARET_PADDING_PX = 18;

  function measureSelectLabelPx(select) {
    const text = select.options[select.selectedIndex]?.text?.trim() || "";
    if (!text) return null;

    const style = getComputedStyle(select);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context) return null;

    context.font = `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
    return Math.ceil(context.measureText(text).width) + CARET_PADDING_PX;
  }

  function syncSortSelectWidth(select) {
    const width = measureSelectLabelPx(select);
    if (width) select.style.width = `${width}px`;
  }

  function initSortSelects(root = document) {
    root.querySelectorAll('select.facet-filters__sort[name="sort_by"]').forEach(syncSortSelectWidth);
  }

  document.addEventListener("change", (event) => {
    const select = event.target;
    if (select?.matches?.('select.facet-filters__sort[name="sort_by"]')) {
      syncSortSelectWidth(select);
    }
  });

  function observeFacetsContainers() {
    document.querySelectorAll(".facets-container").forEach((container) => {
      initSortSelects(container);
      new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            if (node.matches?.('select.facet-filters__sort[name="sort_by"]')) {
              syncSortSelectWidth(node);
              return;
            }
            initSortSelects(node);
          });
        });
      }).observe(container, { childList: true, subtree: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeFacetsContainers);
  } else {
    observeFacetsContainers();
  }
})();
